import amapi from '@/api/amapi'

const initialState = () => ({
  'ssl': null,
  'ssl_error': '',
  'ssl_status': '',
  'ssl_installs': null
})

const state = initialState

const getters = {
  ssl: state => state.ssl,
  ssl_status: state => state.ssl_status,
  ssl_error: state => state.ssl_error,
  ssl_installs: state => state.ssl_installs
}

const mutations = {
  POPULATE_SSL (state, r) {
    if (r) {
      if (r.ssl_status) state.ssl_status = r.ssl_status
      if (r.ssl_error) state.ssl_error = r.ssl_error
      if (r.ssl) state.ssl = r.ssl
    } else {
      state.ssl_status = ''
      state.ssl = null
    }
  },
  POPULATE_SSL_INSTALLS (state, r) {
    if (r) {
      state.ssl_installs = r.installed
    } else {
      state.ssl_installs = []
    }
  },
  POPULATE_SSL_ERROR (state, error) {
    state.ssl_error = error
  },
  CLEAR_SSL_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async getSslDetail ({ dispatch, commit }, id) {
    try {
      const data = {
        id,
        action: 'detail'
      }

      // Set SSL store to initial each time you select a new service
      commit('CLEAR_SSL_STORE')
      commit('POPULATE_SSL_INSTALLS')
      commit('POPULATE_SSL')
      const response = await amapi.makecall('ssl_manage', { ...data })

      commit('POPULATE_SSL', response)
    } catch (e) {
      commit('POPULATE_SSL', {
        ssl: 1,
        ssl_status: 'Error',
        ssl_error: e
      })

      throw e
    }
  },
  async getSslInstalls ({ commit }, id) {
    try {
      const data = { id: id, action: 'status' }

      const response = await amapi.makecall('ssl_manage', { ...data })
      commit('POPULATE_SSL_INSTALLS', response)
    } catch (e) {
      throw e
    }
  },
  async ssldostep ({ commit }, id) {
    try {
      const data = { id: id, action: 'dostep' }

      commit('POPULATE_SSL_ERROR', null)
      const response = await amapi.makecall('ssl_manage', { ...data })
      commit('POPULATE_SSL', response)
    } catch (e) {
      commit('POPULATE_SSL_ERROR', e)
      throw e
    }
  },
  async installSsl ({ dispatch }, params) {
    try {
      const data = {
        id: params.id,
        domain: params.domain,
        action: 'install'
      }
      await amapi.makecall('ssl_manage', { ...data })
      await dispatch('getSslInstalls', params.id)
    } catch (e) {
      throw e
    }
  },
  async uninstallSsl ({ dispatch }, params) {
    try {
      const data = {
        id: params.id,
        domain: params.domain,
        action: 'uninstall'
      }
      await amapi.makecall('ssl_manage', { ...data })
      await dispatch('getSslInstalls', params.id)
    } catch (e) {
      throw e
    }
  },
  clearSslStore ({ commit }) {
    commit('CLEAR_SSL_STORE')
  }
}

const module = {
  state,
  getters,
  mutations,
  actions
}

export default module
